import { ExtractedContract, SourceValue, CoOccupantInfo } from '../types/contract.d';

// --- 型ガード関数 ---
export const isSourceValue = (value: any): value is SourceValue => {
  return !!(value && typeof value === 'object' && 'value' in value && 'source_document' in value && !Array.isArray((value as any).value));
};

export const isCoOccupantInfo = (value: any): value is CoOccupantInfo => {
  return !!(value && typeof value === 'object' && 'value' in value && Array.isArray(value.value));
};

// 表示とCSV出力のための統一されたデータ整形関数
export const getDisplayValue = (item: ExtractedContract, key: keyof ExtractedContract): string => {
    const data: any = item[key];

    if (data && typeof data === 'object') {
        // `value`と`source_document`プロパティの存在を確認
        if ('value' in data && 'source_document' in data) {
            // valueが配列ならCoOccupantInfoと判断
            if (Array.isArray(data.value)) { 
                if (!data.value || data.value.length === 0) return 'N/A';
                return (data.value as any[]).map(p => `${p.name || 'N/A'} (${p.gender || 'N/A'})`).join(', ');
            } else { // それ以外はSourceValueと判断
                const value = data.value;
                if (value === null || value === undefined || value === '') return 'N/A';
                return String(value);
            }
        }
        // その他の予期せぬオブジェクトはJSON文字列化
        return JSON.stringify(data);
    }
    
    if (data === null || data === undefined || data === '') return 'N/A';

    // プリミティブ値はそのまま文字列化
    return String(data);
};
